import { ApplicationType } from '../base';

export interface PermissionApiModel {
  action: string;
  isAllowed: boolean;
}

export interface PermissionFullApiModel {
  id: number;
  userGroupId: number;
  resourcePath: string;
  action: string;
  isAllowed: boolean;
  applicationType: ApplicationType;
}

export interface PermissionPostApiModel {
  resourcePath: string;
  action: string;
  /**
   * Not optional in api request to filteredByAppType
   */
  applicationType?: ApplicationType;
}

export declare type PermissionsList = {
  [key: string]: string | string[] | PermissionsActions;
}

export interface PermissionsActions {
  actions: string | string[];
  applicationType?: ApplicationType;
}

export enum PermissionsCheckMethod {
  AllGranted = 0,
  SomeGranted = 1
}

export interface ParsedPermissions extends PermissionPostApiModel {
  negated?: boolean;
}

export interface PermissionsGuardParams {
  permissionsToLoad?: PermissionsList | PermissionsList[];
  permissionsToCheck?: PermissionsList | PermissionsList[];
  permissionToCheckMethod: PermissionsCheckMethod;
}

export interface AccessRights {
  userGroupId: number;
  permissions: ResourcePermissions[];
  name: string;
  code: string;
}

export interface ResourcePermissions {
  resourcePath: string;
  isAllowed: boolean;
}

export const rightGroupNames = {
  guest: 'SETTINGS.USERS.GUEST.TITLE',
  'team member': 'SETTINGS.USERS.MEMBER.TITLE',
  accountant: 'SETTINGS.USERS.ACCOUNTANT.TITLE'
};
